import { Controller } from "@hotwired/stimulus";

// Tabbed form panels. Opens the first tab with a validation error; otherwise
// restores the tab the organiser last viewed, since toggling a switch reloads
// the form and would otherwise bounce them back to the first tab.
export default class extends Controller {
  static targets = ["tab", "panel"];

  connect() {
    let errorTabId = null;
    this.panelTargets.forEach((panel) => {
      if (!panel.querySelector(".error-list")) return;
      this.#tabFor(panel.dataset.tabId)?.classList.add("has-errors");
      errorTabId ||= panel.dataset.tabId;
    });
    this.activate(errorTabId || this.#rememberedTabId);
  }

  showTab(event) {
    this.activate(event.currentTarget.dataset.tabId);
  }

  activate(tabId) {
    if (!tabId) return;
    this.tabTargets.forEach((tab) => {
      const active = tab.dataset.tabId === tabId;
      tab.classList.toggle("active", active);
      tab.setAttribute("aria-selected", active ? "true" : "false");
      tab.setAttribute("tabindex", active ? "0" : "-1");
    });
    this.panelTargets.forEach((panel) => {
      panel.hidden = panel.dataset.tabId !== tabId;
    });
    sessionStorage.setItem(this.#storageKey, tabId);
  }

  get #storageKey() {
    return `form-tabs:${window.location.pathname}`;
  }

  get #rememberedTabId() {
    const stored = sessionStorage.getItem(this.#storageKey);
    if (this.tabTargets.some((tab) => tab.dataset.tabId === stored)) {
      return stored;
    }
    return this.tabTargets[0]?.dataset.tabId;
  }

  #tabFor(tabId) {
    return this.tabTargets.find((tab) => tab.dataset.tabId === tabId);
  }
}
